module.exports = __webpack_public_path__ + "fonts/Inter-700-greek-ext48.2329210.woff2";